import { render, staticRenderFns } from "./mystep.vue?vue&type=template&id=6052c165&scoped=true"
import script from "./mystep.vue?vue&type=script&lang=js"
export * from "./mystep.vue?vue&type=script&lang=js"
import style0 from "./mystep.vue?vue&type=style&index=0&id=6052c165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6052c165",
  null
  
)

export default component.exports